import { api } from "../Configurations/axios";
import { CompanyFinepModel } from "../Models/CompanyFinepModel";

const GetAllCompanyFinep = async (id: string) => {
    try {
        var result = await api.get(`/CompanyFINEP/GetAllByRegister/${id}`);
        var response = result.data;
        return response.data;
    } catch(error: any) {
        throw new Error(error.response.data);
    }
}

const HasOtherCompany = async (id: string) => {
    try {
        var result = await api.get(`/CompanyFINEP/HasAnyByRegister/${id}`);
        var response = result.data;
        return response.data;
    } catch(error: any) {
        throw new Error(error.response.data);
    }
}

const GetCompanyFinep = async (id: string) => {
    try {
        var result = await api.get(`/CompanyFINEP/GetById/${id}`);
        var response = result.data;
        return response.data;
    } catch(error: any) {
        throw new Error(error.response.data);
    }
}

const CreateCompanyFinep = async (company: CompanyFinepModel) => {
    try {
        var result = await api.post(`/CompanyFINEP/CreateCompanyFinep`, company);
        var response = result.data;
        return response;
    } catch(error: any) {
        throw new Error(error.response.data);
    }
}

const EditCompanyFinep = async (company: CompanyFinepModel) => {
    try {
        var result = await api.put(`/CompanyFINEP/UpdateCompanyFINEP`, company);
        var response = result.data;
        return response;
    } catch(error: any) {
        throw new Error(error.response.data);
    }
}

interface EditAnonymousSocietyCompanyFinepProps{
    id: string;
    isAnonymousSociety: boolean;
    userEmail: string;
}

const EditAnonymousSocietyCompanyFINEP = async (company: EditAnonymousSocietyCompanyFinepProps) => {
    try {
        var result = await api.put(`/CompanyFINEP/UpdateAnonymousSocietyCompanyFINEP`, company);
        var response = result.data;
        return response;
    } catch(error: any) {
        throw new Error(error.response.data);
    }
}

interface ValidateCompanyFinepProps{
    id: string;
    isContentValid: boolean;
    userEmail: string;
}

const ValidateCompanyFinep = async (company: ValidateCompanyFinepProps) => {
    try {
        var result = await api.put(`/CompanyFINEP/ValidateCompanyFinep`, company);
        var response = result.data;
        return response;
    } catch(error: any) {
        throw new Error(error.response.data);
    }
}

export {
    GetCompanyFinep,
    HasOtherCompany,
    GetAllCompanyFinep,
    CreateCompanyFinep,
    EditCompanyFinep,
    EditAnonymousSocietyCompanyFINEP,
    ValidateCompanyFinep
}